import axios, { type AxiosInstance } from 'axios';
import MockAdapter from 'axios-mock-adapter';
import Fakedata from '@/api/fakedata/v1';
import * as Common from '@/libs/Common';
import DOMPurify from 'dompurify';
// Override timeout default for the library
const config = {
    headers: {
        'Content-Type': 'application/json'
    },
    defaults: {
        baseURL: import.meta.env.VITE_BaseUrl,
        timeout: import.meta.env.VITE_CallApiTimeout,
        withCredentials: true
    }
};
const ServiceAlertApiClient = axios.create(config);

ServiceAlertApiClient.defaults.baseURL = import.meta.env.VITE_WebUrl + import.meta.env.VITE_BaseUrl;
ServiceAlertApiClient.defaults.timeout = import.meta.env.VITE_CallApiTimeout;
ServiceAlertApiClient.defaults.withCredentials = true;

ServiceAlertApiClient.interceptors.request.use(
    async (_config) => {
        // 3.bind XSCRF-token in to request headers
        let requestToken;
        if (import.meta.env.PROD) {
            const requestTokenEle = document.querySelector(`meta[name="${import.meta.env.VITE_XSRFKey_HeaderName}"]`) as HTMLMetaElement;

            if (requestTokenEle && requestTokenEle.content) {
                requestToken = requestTokenEle.content;
            }
        }
        _config.headers[import.meta.env.VITE_XSRFKey_HeaderName] = requestToken;

        // xss filter
        if (_config.params) {
            for (const key in _config.params) {
                if (Object.prototype.hasOwnProperty.call(_config.params, key)) {
                    _config.params[key] = Common.ReplaceSpecialChar(DOMPurify.sanitize(_config.params[key]));
                }
            }
        }
        return _config;
    },
    (error) => {
        return Promise.reject(error);
    }
);
/**
 * @todo mock data
 */
if (import.meta.env.VITE_ENABLE_FAKE_DATA === 'true') {
    ((axios: AxiosInstance) => {
        const mock = new MockAdapter(axios, { delayResponse: 500 });

        mock.onAny().reply(function (config): [number, any] {
            const response = Fakedata.find(([method, path, data]) => {
                return (
                    config?.url?.match(new RegExp(`^${path}$`)) &&
                    config.method?.toUpperCase() === (method as string).toUpperCase() &&
                    (Object.keys(data as object).length === 0 || config?.data?.toString() === JSON.stringify(data))
                );
            });

            // Unexpected request, error out
            if (!response) {
                return [500, {}];
            }

            return response.slice(3) as [number, any];
        });
    })(ServiceAlertApiClient);
}
export { ServiceAlertApiClient };
